// Environment configuration helper
// Supports both build-time (process.env) and runtime (window.ENV) variables

const getEnvVariable = (key) => {
  // First try runtime config (for production without build-time env vars)
  if (typeof window !== 'undefined' && window.ENV && window.ENV[key]) {
    return window.ENV[key];
  }
  
  // Fallback to build-time environment variables (for local development)
  return process.env[key];
};

export const ENV = {
  SUPABASE_URL: getEnvVariable('REACT_APP_SUPABASE_URL'),
  SUPABASE_ANON_KEY: getEnvVariable('REACT_APP_SUPABASE_ANON_KEY'),
  GOOGLE_MAPS_API_KEY: getEnvVariable('REACT_APP_GOOGLE_MAPS_API_KEY'),
  NODE_ENV: process.env.NODE_ENV || 'development'
};

export default ENV;
